export const PutHistoryRead = Symbol('PutHistoryRead');

export interface PutHistoryRead {
    putHistoryRead(taskId: string): Promise<void>;
}